import { ListItemIcon, ListItemText } from "@mui/material";

import { useStyles } from "../styles";

// Generic ListItem component
export const ListItem = ({
  icon,
  primaryText,
  customIcon,
}: {
  icon?: React.ReactNode;
  primaryText: string;
  customIcon?: React.ReactNode;
}) => {
  const classes = useStyles();

  return (
    <>
      <ListItemIcon className={classes.ListItemIconStyle}>
        {customIcon || icon}
      </ListItemIcon>
      <ListItemText primary={primaryText} />
    </>
  );
};
